import { h } from '@stencil/core';
/**
 * Generates the rendering of a UI component from a JSON.
 * Before using this method, it is necessary to call Stencil's h function as follows: h('div', { color: '', key: '1' })
 * @param componentContent - Content of the UI component.
 * @returns - Rendered component.
 */
export function renderComponent(componentContent) {
    return h(componentContent.tag, componentContent.node, parseChildren(componentContent.children));
}
function parseChildren(children) {
    if (children.length < 1) {
        return [null];
    }
    return children.map((child) => {
        if (typeof child === 'string') {
            return child;
        }
        return h(child.tag, child.node, parseChildren(child.children));
    });
}
